export default {
  select: {
    input: `\
      appearance-none \
      bg-chevron-down \
      bg-[right_5px_center] \
      bg-no-repeat \
      pr-[24px]
    `,
  },
  radio: {
    fieldset: 'border-none m-0 p-0',
    options: 'm-0 p-0 flex flex-col gap-2xs mt-2xs',
    option: 'list-none',
    legend: 'text-medium text-xs',
  },
  'dbc-tel': {
    outer: '$reset formkit-outer',
    label: '$reset fromkit-label',
    inner: `\
      $reset \
      formkit-inner \
      flex \
      gap-x-4 \
      w-full \
    `,
    input: '$reset formkit-input',
    tel: `\
      flex \
      items-center \
      gap-[6px] \
      bg-input \
      border-b \
      border-t-0 \
      border-x-0 \
      border-solid \
      rounded \
      border-input \
      focus-within:border-focus \
      focus-within:ring-2 \
      focus-within:ring-blue-400 \
      p-[10px] \
      group-data-[disabled]:!bg-inactive \
      group-data-[disabled]:!cursor-not-allowed \
    `,
    'tel-select': `\
      !p-0 \
    `,
    'tel-select-input': `\
      placeholder:!text-placeholder \
      p-[10px] \
      border-0 \
      bg-input \
      outline-none \
      rounded \
      resize-none \
      group-data-[disabled]:!bg-inactive \
      group-data-[disabled]:!cursor-not-allowed \
      text-base \
      leading-snug \
      appearance-none \
      bg-chevron-down \
      bg-[right_5px_center] \
      bg-no-repeat \
      pr-[24px] \
      h-[44px] \
    `,
    'tel-input-input': `\
      w-full
    `,
  },
  submit: {
    input: `\
      text-white \
      bg-button \
      hover:bg-button-hover \
      active:bg-button-pressed \
      group-data-[disabled]:!bg-inactive \
      group-data-[disabled]:text-dark \
      group-data-[disabled]:cursor-not-allowed \
    `,
  },
  button: {
    input: `\
      text-dark \
      bg-white \
      hover:bg-gray \
      active:bg-gray \
      border-[1px] \
      border-solid \
      border-dark \
      active:border-focus \
      group-data-[disabled]:!bg-inactive \
      group-data-[disabled]:text-dark \
      group-data-[disabled]:cursor-not-allowed \
    `,
  },
}
